import {
  Component,
  Prop,
  Element,
  Event,
  EventEmitter,
  h,
  Listen,
  Host,
} from "@stencil/core";

@Component({
  tag: "scs-autocomplete-quick-link-option",
  styleUrls: ["autocomplete-quick-link-option.scss"],
  shadow: true,
})
export class AutocompleteQuickLinks {
  private autocompleteEl!: HTMLScsAutocompleteElement;

  @Element() host!: HTMLScsAutocompleteQuickLinkOptionElement;
  /** @internal defines if current option is displayed as focused, only used by autocomplete element */
  @Prop() hasFocus: boolean = false;
  /** href to link the item  */
  @Prop() href: string = "javascript:void(0)";

  @Event()
  autocompleteOptionLoaded!: EventEmitter<HTMLScsAutocompleteQuickLinkOptionElement>;
  @Event()
  autocompleteOptionSelected!: EventEmitter<HTMLScsAutocompleteQuickLinkOptionElement>;

  @Listen("click")
  clickHandler() {
    this.autocompleteOptionSelected.emit(this.host);
  }

  @Listen("keydown", { target: "window" })
  keydownHandler(ev: KeyboardEvent) {
    if (ev.key === "Enter" && this.hasFocus) {
      this.autocompleteOptionSelected.emit(this.host);
    }
  }

  componentWillLoad() {
    this.autocompleteEl = this.host.closest(
      "scs-autocomplete",
    ) as HTMLScsAutocompleteElement;
  }

  componentDidLoad() {
    this.autocompleteOptionLoaded.emit(this.host);
  }

  disconnectedCallback() {
    this.autocompleteEl.autocompleteOptionRemoved();
  }

  render() {
    return (
      <Host
        role="option"
        aria-selected={this.hasFocus}
        class={{
          "autocomoplete-quick-link-option": true,
          focus: this.hasFocus,
        }}
      >
        <a href={this.href} class="quick-link">
          <sdx-icon
            class="quick-link__icon"
            iconName="icon-chevron-normal-left"
            colorClass="int-blue"
            flip="horizontal"
            aria-hidden="true"
          />
          <span class="quick-link__text">
            <slot />
          </span>
        </a>
      </Host>
    );
  }
}
